import { useState } from "react";
import { CreateBase, Form, useGetIdentity, useTranslate, useNotify } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { CancelButton } from "@/components/admin/cancel-button";
import { SaveButton } from "@/components/admin/form";

import { CompanyInputs } from "./CompanyInputs";

export const CompanyCreate = () => {
  const { identity } = useGetIdentity();
  const translate = useTranslate();
  const notify = useNotify();
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [duplicateCompany, setDuplicateCompany] = useState<any>(null);

  return (
    <CreateBase
      redirect="show"
      transform={(values) => {
        if (isDuplicate && duplicateCompany) {
          notify(`Cannot create duplicate company: "${duplicateCompany.name}" already exists.`, {
            type: "error",
          });
          throw new Error(`Company "${duplicateCompany.name}" already exists`);
        }
        // add https:// before website if not present
        if (values.website && !values.website.startsWith("http")) {
          values.website = `https://${values.website}`;
        }
        return values;
      }}
    >
      <div className="mt-2 flex lg:mr-72">
        <div className="flex-1">
          <Form defaultValues={{ sales_id: identity?.id }}>
            <Card>
              <CardContent>
                <CompanyInputs
                  onDuplicateChange={(isDup, company) => {
                    setIsDuplicate(isDup);
                    setDuplicateCompany(company);
                  }}
                />
                <div
                  role="toolbar"
                  className="sticky flex pt-4 pb-4 md:pb-0 bottom-0 bg-linear-to-b from-transparent to-card to-10% flex-row justify-end items-center gap-3"
                >
                  {isDuplicate && (
                    <span className="text-xs text-amber-600 dark:text-amber-400 font-medium">
                      Duplicate detected — open existing record above or change name
                    </span>
                  )}
                  <CancelButton />
                  <SaveButton
                    disabled={isDuplicate}
                    label={translate("resources.companies.action.create", {
                      _: "Create Company",
                    })}
                  />
                </div>
              </CardContent>
            </Card>
          </Form>
        </div>
      </div>
    </CreateBase>
  );
};
